import { computed, Injectable } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import { StoreService } from '../../store/store.service';
import { DAY_OF_WEEK_NAMES, DAY_OF_WEEK_NAMES_FOR_DATES, MONTH_NAMES } from '../configs/common.config';
import { CommonService } from './common.service';

@Injectable({ providedIn: 'root' })
export class CustomNGBDatepickerI18n extends NgbDatepickerI18n {
  private weekdays = computed<string[]>(() => {
    const isMobileScreen = this.storeSvc.res()?.mobile ?? false;
    const isUpperCaseLabel = this.storeSvc.appStore.isUpperCaseLabel();
    const localeObj = this.storeSvc.localeObj();
    const DAY_OF_WEEK_LABELS = isMobileScreen ? DAY_OF_WEEK_NAMES : DAY_OF_WEEK_NAMES_FOR_DATES;

    return DAY_OF_WEEK_LABELS.map((labelName: string) =>
      this.commonSvc.getUpperCaseString(isUpperCaseLabel, localeObj[labelName]),
    );
  });
  private months = computed<string[]>(() => {
    const isUpperCaseLabel = this.storeSvc.appStore.isUpperCaseLabel();
    const localeObj = this.storeSvc.localeObj();

    return MONTH_NAMES.map((labelName: string) =>
      this.commonSvc.getUpperCaseString(isUpperCaseLabel, localeObj[labelName]),
    );
  });

  constructor(
    private storeSvc: StoreService,
    private commonSvc: CommonService,
  ) {
    super();
  }

  getWeekdayShortName(weekday: number): string {
    return this.weekdays()[weekday % 7]; // 0-based index
  }

  getWeekdayLabel(weekday: number): string {
    return this.weekdays()[weekday % 7]; // 0-based index
  }

  getMonthShortName(month: number): string {
    return this.months()[month - 1]; // 1-based index
  }

  getMonthFullName(month: number): string {
    return this.months()[month - 1]; // 1-based index
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day} ${this.getMonthFullName(date.month)} ${date.year}`;
  }
}
